import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@material-ui/core";
import { useTranslate, useMutation, useNotify, useRefresh } from "react-admin";
import { get } from "lodash";

const EditDialog = ({ userPayment, onClose }) => {
  const translate = useTranslate();
  const refresh = useRefresh();
  const notify = useNotify();
  const [data, setData] = useState({ ...userPayment, user: null });
  const handleAdjustementAmountChange = (e) => {
    let amount = isNaN(parseFloat(e.target.value))
      ? 0
      : parseFloat(e.target.value);

    setData({
      ...data,
      amount:
        get(userPayment, "amount", 0) -
        get(userPayment, "adjustements[0].amount", 0) +
        amount,
      adjustements: [
        {
          ...get(data, "adjustements[0]", {}),
          amount,
        },
      ],
    });
  };

  const handleAmountChange = (e) => {
    let amount = isNaN(parseFloat(e.target.value))
      ? 0
      : parseFloat(e.target.value);
    setData({
      ...data,
      amount,
      adjustements: [
        {
          ...get(data, "adjustements[0]", {}),
          amount:
            amount -
            get(userPayment, "amount", 0) +
            get(userPayment, "adjustements[0].amount", 0),
        },
      ],
    });
  };
  const handleDescriptionChange = (e) =>
    setData({
      ...data,
      adjustements: [
        {
          ...get(data, "adjustements[0]", {}),
          description: e.target.value,
        },
      ],
    });

  const handleClose = () => onClose(userPayment);
  const [requestAdjust, { loading }] = useMutation(
    {
      type: "update",
      resource: "user-payments",
      payload: {
        id: userPayment.id,
        data: {
          ...data,
        },
      },
    },
    {
      onSuccess: ({ data }) => {
        onClose(userPayment, true);
        refresh();
        notify(
          translate(`resources.user-payments-adjustements.messages.success`)
        );
      },
      onFailure: (error) => {
        onClose(userPayment, false);
        notify(
          translate("resources.user-payments-adjustements.messages.fail"),
          "warning"
        );
      },
    }
  );
  const hasDescription = get(data, "adjustements[0].description", "") !== "";

  return (
    <Dialog open={userPayment !== null}>
      <DialogTitle>
        {translate(`resources.user-payment-adjustements.name`)}
      </DialogTitle>
      <DialogContent>
        <Typography variant="subtitle1">
          {translate(
            "resources.user-payments-adjustements.original_import",
            userPayment
          )}
        </Typography>
        <TextField
          value={get(data, "adjustements[0].amount", 0)}
          onChange={handleAdjustementAmountChange}
          autoFocus
          required
          margin="dense"
          id="adjustements_0_amount"
          label={translate("resources.user-payment-adjustements.fields.amount")}
          type="number"
          fullWidth
        />
        <TextField
          value={get(data, "amount", 0)}
          onChange={handleAmountChange}
          autoFocus
          required
          margin="dense"
          id="amount"
          label={translate("resources.user-payments.fields.amount")}
          type="number"
          fullWidth
        />
        <TextField
          error={!hasDescription}
          helperText={
            !hasDescription ? translate("ra.validation.required") : ""
          }
          value={get(data, "adjustements[0].description")}
          onChange={handleDescriptionChange}
          autoFocus
          required
          margin="dense"
          id="description"
          label={translate(
            "resources.user-payment-adjustements.fields.description"
          )}
          type="text"
          multiline
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={requestAdjust} disabled={!hasDescription || loading}>
          {translate(`resources.user-payment-adjustements.buttons.confirm`)}
        </Button>
        <Button onClick={handleClose} disabled={loading}>
          {translate("ra.action.cancel")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
EditDialog.propTypes = {
  id: PropTypes.number,
  userPayment: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};
export default EditDialog;
